export const municipis = [
  'Nom del municipi',
  'Abella de la Conca',
  'Abrera',
  'Àger',
  'Agramunt',
  'Aguilar de Segarra',
  'Agullana',
  'Aiguafreda',
  'Aiguamúrcia',
  'Aiguaviva',
  'Aitona',
  'els Alamús',
  'Alàs i Cerc',
  "l'Albagés",
  'Albanyà',
  'Albatàrrec',
  'Albesa',
  "l'Albi",
  'Albinyana',
  "l'Albiol",
  'Albons',
  'Alcanar',
  'Alcanó',
  'Alcarràs',
  'Alcoletge',
  'Alcover',
  "l'Aldea",
  'Aldover',
  "l'Aleixar",
  'Alella',
  'Alfara de Carles',
  'Alfarràs',
  'Alfés',
  'Alforja',
  'Algerri',
  'Alguaire',
  'Alins',
  'Alió',
  'Almacelles',
  'Almatret',
  'Almenar',
  'Almoster',
  'Alòs de Balaguer',
  'Alp',
  'Alpens',
  'Alpicat',
  'Alt Àneu',
  'Altafulla',
  'Amer',
  "l'Ametlla de Mar",
  "l'Ametlla del Vallès",
  "l'Ampolla",
  'Amposta',
  'Anglès',
  'Anglesola',
  'Arbeca',
  "l'Arboç",
  'Arbolí',
  'Arbúcies',
  'Arenys de Mar',
  'Arenys de Munt',
  'Argelaguer',
  'Argençola',
  "l'Argentera",
  'Argentona',
  "l'Armentera",
  'Arnes',
  'Arres',
  'Arsèguel',
  'Artés',
  'Artesa de Lleida',
  'Artesa de Segre',
  'Ascó',
  'Aspa',
  'les Avellanes i Santa Linya',
  'Avià',
  'Avinyó',
  'Avinyonet de Puigventós',
  'Avinyonet del Penedès',
  'Badalona',
  'Badia del Vallès',
  'Bagà',
  'Baix Pallars',
  'Balaguer',
  'Balenyà',
  'Balsareny',
  'Banyeres del Penedès',
  'Banyoles',
  'Barbens',
  'Barberà de la Conca',
  'Barberà del Vallès',
  'Barcelona',
  'la Baronia de Rialb',
  'Bàscara',
  'Bassella',
  'Batea',
  'Bausen',
  'Begues',
  'Begur',
  'Belianes',
  'Bellaguarda',
  "Bellcaire d'Empordà",
  "Bellcaire d'Urgell",
  "Bell-lloc d'Urgell",
  'Bellmunt del Priorat',
  "Bellmunt d'Urgell",
  'Bellprat',
  'Bellpuig',
  'Bellvei',
  'Bellver de Cerdanya',
  'Bellvís',
  'Benavent de Segrià',
  'Benifallet',
  'Benissanet',
  'Berga',
  'Besalú',
  'Bescanó',
  'Beuda',
  'Bigues i Riells del Fai',
  'Biosca',
  'la Bisbal de Falset',
  'la Bisbal del Penedès',
  "la Bisbal d'Empordà",
  'Biure',
  'Blancafort',
  'Blanes',
  'Boadella i les Escaules',
  'Bolvir',
  'Bonastre',
  'Es Bòrdes',
  'Bordils',
  'les Borges Blanques',
  'les Borges del Camp',
  'Borrassà',
  'Borredà',
  'Bossòst',
  'Bot',
  'Botarell',
  'Bovera',
  'Bràfim',
  'Breda',
  'el Bruc',
  'el Brull',
  'Brunyola i Sant Martí Sapresa',
  'Cabacés',
  'Cabanabona',
  'Cabanelles',
  'Cabanes',
  'les Cabanyes',
  'Cabó',
  'Cabra del Camp',
  "Cabrera d'Anoia",
  'Cabrera de Mar',
  'Cabrils',
  'Cadaqués',
  'Calaf',
  'Calafell',
  'Calders',
  'Caldes de Malavella',
  'Caldes de Montbui',
  "Caldes d'Estrac",
  'Calella',
  'Calldetenes',
  'Callús',
  'Calonge de Segarra',
  'Calonge i Sant Antoni',
  'Camarasa',
  'Camarles',
  'Cambrils',
  'Camós',
  'Campdevànol',
  'Campelles',
  'Campins',
  'Campllong',
  'Camprodon',
  'Canejan',
  "Canet d'Adri",
  'Canet de Mar',
  'la Canonja',
  'Canovelles',
  'Cànoves i Samalús',
  'Cantallops',
  'Canyelles',
  'Capafonts',
  'Capçanes',
  'Capellades',
  'Capmany',
  'Capolat',
  'Cardedeu',
  'Cardona',
  'Carme',
  'Caseres',
  'Cassà de la Selva',
  'Casserres',
  "Castell de l'Areny",
  'Castell de Mur',
  'Castellar de la Ribera',
  "Castellar de n'Hug",
  'Castellar del Riu',
  'Castellar del Vallès',
  'Castellbell i el Vilar',
  'Castellbisbal',
  'Castellcir',
  'Castelldans',
  'Castelldefels',
  'Castellet i la Gornal',
  'Castellfollit de la Roca',
  'Castellfollit de Riubregós',
  'Castellfollit del Boix',
  'Castellgalí',
  'Castellnou de Bages',
  'Castellnou de Seana',
  'Castelló de Farfanya',
  "Castelló d'Empúries",
  'Castellolí',
  "Castell-Platja d'Aro",
  'Castellserà',
  'Castellterçol',
  'Castellvell del Camp',
  'Castellví de la Marca',
  'Castellví de Rosanes',
  'el Catllar',
  'Cava',
  'la Cellera de Ter',
  'Celrà',
  'Centelles',
  'Cercs',
  'Cerdanyola del Vallès',
  'Cervelló',
  'Cervera',
  'Cervià de les Garrigues',
  'Cervià de Ter',
  'Cistella',
  'Ciutadilla',
  'Clariana de Cardener',
  'el Cogul',
  'Colera',
  'Coll de Nargó',
  'Collbató',
  'Colldejou',
  'Collsuspina',
  'Colomers',
  'la Coma i la Pedra',
  'Conca de Dalt',
  'Conesa',
  'Constantí',
  'Copons',
  'Corbera de Llobregat',
  "Corbera d'Ebre",
  'Corbins',
  'Corçà',
  'Cornellà de Llobregat',
  'Cornellà del Terri',
  'Cornudella de Montsant',
  'Creixell',
  'Crespià',
  "Cruïlles, Monells i Sant Sadurní de l'Heura",
  'Cubelles',
  'Cubells',
  'Cunit',
  'Darnius',
  'Das',
  'Deltebre',
  'Dosrius',
  'Duesaigües',
  "l'Escala",
  'Esparreguera',
  'Espinelves',
  "l'Espluga Calba",
  "l'Espluga de Francolí",
  'Esplugues de Llobregat',
  'Espolla',
  'Esponellà',
  'Espot',
  "l'Espunyola",
  "l'Esquirol",
  'Estamariu',
  "l'Estany",
  'Estaràs',
  "Esterri d'Àneu",
  'Esterri de Cardós',
  'Falset',
  "el Far d'Empordà",
  'Farrera',
  'la Fatarella',
  'la Febró',
  'Figaró-Montmany',
  'Fígols',
  'Fígols i Alinyà',
  'la Figuera',
  'Figueres',
  'Figuerola del Camp',
  'Flaçà',
  'Flix',
  'la Floresta',
  'Fogars de la Selva',
  'Fogars de Montclús',
  'Foixà',
  'Folgueroles',
  'Fondarella',
  'Fonollosa',
  'Fontanals de Cerdanya',
  'Fontanilles',
  'Fontcoberta',
  'Font-rubí',
  'Foradada',
  'Forallac',
  'Forès',
  'Fornells de la Selva',
  'Fortià',
  'les Franqueses del Vallès',
  'Freginals',
  'la Fuliola',
  'Fulleda',
  'Gaià',
  'la Galera',
  'Gallifa',
  'Gandesa',
  'Garcia',
  'els Garidells',
  'la Garriga',
  'Garrigàs',
  'Garrigoles',
  'Garriguella',
  'Gavà',
  'Gavet de la Conca',
  'Gelida',
  'Ger',
  'Gimenells i el Pla de la Font',
  'Ginestar',
  'Girona',
  'Gironella',
  'Gisclareny',
  'Godall',
  'Golmés',
  'Gombrèn',
  'Gósol',
  'la Granada',
  'la Granadella',
  'Granera',
  "la Granja d'Escarp",
  'Granollers',
  'Granyanella',
  'Granyena de les Garrigues',
  'Granyena de Segarra',
  'Gratallops',
  'Gualba',
  'Gualta',
  'Guardiola de Berguedà',
  'els Guiamets',
  'Guils de Cerdanya',
  'Guimerà',
  "la Guingueta d'Àneu",
  'Guissona',
  'Guixers',
  'Gurb',
  'Horta de Sant Joan',
  "l'Hospitalet de Llobregat",
  'els Hostalets de Pierola',
  'Hostalric',
  'Igualada',
  'Isona i Conca Dellà',
  'Isòvol',
  'Ivars de Noguera',
  "Ivars d'Urgell",
  'Ivorra',
  'Jafre',
  'la Jonquera',
  'Jorba',
  'Josa i Tuixén',
  'Juià',
  'Juncosa',
  'Juneda',
  'Les',
  'Linyola',
  'la Llacuna',
  'Lladó',
  'Lladorre',
  'Lladurs',
  'la Llagosta',
  'Llagostera',
  'Llambilles',
  'Llanars',
  'Llançà',
  'Llardecans',
  'Llavorsí',
  'Lleida',
  'Llers',
  'Lles de Cerdanya',
  "Lliçà d'Amunt",
  'Lliçà de Vall',
  'Llimiana',
  'Llinars del Vallès',
  'Llívia',
  'el Lloar',
  'Llobera',
  'Llorac',
  'Llorenç del Penedès',
  'Lloret de Mar',
  'les Llosses',
  'Lluçà',
  'Maçanet de Cabrenys',
  'Maçanet de la Selva',
  'Madremanya',
  'Maià de Montcal',
  'Maials',
  'Maldà',
  'Malgrat de Mar',
  'Malla',
  'Manlleu',
  'Manresa',
  'Marçà',
  'Margalef',
  'Marganell',
  'Martorell',
  'Martorelles',
  'Mas de Barberans',
  'Masarac',
  'Masdenverge',
  'les Masies de Roda',
  'les Masies de Voltregà',
  'Masllorenç',
  'el Masnou',
  'la Masó',
  'Maspujols',
  'Masquefa',
  'el Masroig',
  'Massalcoreig',
  'Massanes',
  'Massoteres',
  'Matadepera',
  'Mataró',
  'Mediona',
  'Menàrguens',
  'Meranges',
  'Mieres',
  'el Milà',
  'Miralcamp',
  'Miravet',
  'Moià',
  'el Molar',
  'Molins de Rei',
  'Mollerussa',
  'Mollet de Peralada',
  'Mollet del Vallès',
  'Molló',
  'la Molsosa',
  'Monistrol de Calders',
  'Monistrol de Montserrat',
  'Montagut i Oix',
  'Montblanc',
  'Montbrió del Camp',
  'Montcada i Reixac',
  'Montclar',
  'Montellà i Martinet',
  'Montesquiu',
  'Montferrer i Castellbò',
  'Montferri',
  'Montgai',
  'Montgat',
  'Montmajor',
  'Montmaneu',
  'el Montmell',
  'Montmeló',
  'Montoliu de Lleida',
  'Montoliu de Segarra',
  'Montornès de Segarra',
  'Montornès del Vallès',
  'Mont-ral',
  'Mont-ras',
  'Mont-roig del Camp',
  'Montseny',
  "Móra d'Ebre",
  'Móra la Nova',
  'el Morell',
  'la Morera de Montsant',
  'Muntanyola',
  'Mura',
  'Nalec',
  'Naut Aran',
  'Navarcles',
  'Navàs',
  'Navata',
  'Navès',
  'la Nou de Berguedà',
  'la Nou de Gaià',
  'Nulles',
  'Odèn',
  'Òdena',
  'Ogassa',
  'Olèrdola',
  'Olesa de Bonesvalls',
  'Olesa de Montserrat',
  'Oliana',
  'Oliola',
  'Olius',
  'Olivella',
  'Olost',
  'Olot',
  'les Oluges',
  'Olvan',
  'els Omellons',
  'els Omells de na Gaia',
  'Ordis',
  'Organyà',
  'Orís',
  'Oristà',
  'Orpí',
  'Òrrius',
  'Os de Balaguer',
  'Osor',
  'Ossó de Sió',
  'Pacs del Penedès',
  'Palafolls',
  'Palafrugell',
  'Palamós',
  "el Palau d'Anglesola",
  'Palau de Santa Eulàlia',
  'Palau-sator',
  'Palau-saverdera',
  'Palau-solità i Plegamans',
  'els Pallaresos',
  'Pallejà',
  'la Palma de Cervelló',
  "la Palma d'Ebre",
  'Palol de Revardit',
  'Pals',
  'el Papiol',
  'Pardines',
  'Parets del Vallès',
  'Parlavà',
  'Passanant i Belltall',
  'Pau',
  'Paüls',
  'Pedret i Marzà',
  'Penelles',
  'la Pera',
  'Perafita',
  'Perafort',
  'Peralada',
  'Peramola',
  'el Perelló',
  'Piera',
  'les Piles',
  'Pineda de Mar',
  'el Pinell de Brai',
  'Pinell de Solsonès',
  'Pinós',
  'Pira',
  'el Pla de Santa Maria',
  'el Pla del Penedès',
  "les Planes d'Hostoles",
  'Planoles',
  'els Plans de Sió',
  'el Poal',
  'la Pobla de Cérvoles',
  'la Pobla de Claramunt',
  'la Pobla de Lillet',
  'la Pobla de Mafumet',
  'la Pobla de Massaluca',
  'la Pobla de Montornès',
  'la Pobla de Segur',
  'Poboleda',
  'Polinyà',
  "el Pont d'Armentera",
  'el Pont de Bar',
  'Pont de Molins',
  'el Pont de Suert',
  'el Pont de Vilomara i Rocafort',
  'Pontils',
  'Pontons',
  'Pontós',
  'Ponts',
  'Porqueres',
  'Porrera',
  'el Port de la Selva',
  'Portbou',
  'la Portella',
  'Pradell de la Teixeta',
  'Prades',
  'Prat de Comte',
  'el Prat de Llobregat',
  'Pratdip',
  'Prats de Lluçanès',
  'els Prats de Rei',
  'Prats i Sansor',
  'Preixana',
  'Preixens',
  'Premià de Dalt',
  'Premià de Mar',
  'les Preses',
  'Prullans',
  'Puigcerdà',
  'Puigdàlber',
  'Puiggròs',
  'Puigpelat',
  'Puig-reig',
  "Puigverd d'Agramunt",
  'Puigverd de Lleida',
  'Pujalt',
  'la Quar',
  'Quart',
  'Queralbs',
  'Querol',
  'Rabós',
  'Rajadell',
  'la Ràpita',
  'Rasquera',
  'Regencós',
  'Rellinars',
  'Renau',
  'Reus',
  'Rialp',
  'la Riba',
  "Riba-roja d'Ebre",
  "Ribera d'Ondara",
  "Ribera d'Urgellet",
  'Ribes de Freser',
  'Riells i Viabrea',
  'la Riera de Gaià',
  'Riner',
  'Ripoll',
  'Ripollet',
  'Riu de Cerdanya',
  'Riudarenes',
  'Riudaura',
  'Riudecanyes',
  'Riudecols',
  'Riudellots de la Selva',
  'Riudoms',
  'Riumors',
  'la Roca del Vallès',
  'Rocafort de Queralt',
  'Roda de Berà',
  'Roda de Ter',
  'Rodonyà',
  'Roquetes',
  'Roses',
  'Rosselló',
  'el Rourell',
  'Rubí',
  'Rubió',
  'Rupià',
  'Rupit i Pruit',
  'Sabadell',
  'Sagàs',
  'Salàs de Pallars',
  'Saldes',
  'Sales de Llierca',
  'Sallent',
  'Salomó',
  'Salou',
  'Salt',
  'Sanaüja',
  'Sant Adrià de Besòs',
  'Sant Agustí de Lluçanès',
  'Sant Andreu de la Barca',
  'Sant Andreu de Llavaneres',
  'Sant Andreu Salou',
  'Sant Aniol de Finestres',
  'Sant Antoni de Vilamajor',
  'Sant Bartomeu del Grau',
  'Sant Boi de Llobregat',
  'Sant Boi de Lluçanès',
  'Sant Cebrià de Vallalta',
  'Sant Celoni',
  'Sant Climent de Llobregat',
  'Sant Climent Sescebes',
  'Sant Cugat del Vallès',
  'Sant Cugat Sesgarrigues',
  'Sant Esteve de la Sarga',
  'Sant Esteve de Palautordera',
  'Sant Esteve Sesrovires',
  'Sant Feliu de Buixalleu',
  'Sant Feliu de Codines',
  'Sant Feliu de Guíxols',
  'Sant Feliu de Llobregat',
  'Sant Feliu de Pallerols',
  'Sant Feliu Sasserra',
  'Sant Ferriol',
  'Sant Fost de Campsentelles',
  'Sant Fruitós de Bages',
  'Sant Gregori',
  'Sant Guim de Freixenet',
  'Sant Guim de la Plana',
  'Sant Hilari Sacalm',
  'Sant Hipòlit de Voltregà',
  'Sant Iscle de Vallalta',
  'Sant Jaume de Frontanyà',
  'Sant Jaume de Llierca',
  'Sant Jaume dels Domenys',
  "Sant Jaume d'Enveja",
  'Sant Joan de les Abadesses',
  'Sant Joan de Mollet',
  'Sant Joan de Vilatorrada',
  'Sant Joan Despí',
  'Sant Joan les Fonts',
  'Sant Jordi Desvalls',
  'Sant Julià de Cerdanyola',
  'Sant Julià de Ramis',
  'Sant Julià de Vilatorta',
  'Sant Julià del Llor i Bonmatí',
  'Sant Just Desvern',
  'Sant Llorenç de la Muga',
  'Sant Llorenç de Morunys',
  "Sant Llorenç d'Hortons",
  'Sant Llorenç Savall',
  "Sant Martí d'Albars",
  'Sant Martí de Centelles',
  'Sant Martí de Llémena',
  'Sant Martí de Riucorb',
  'Sant Martí de Tous',
  'Sant Martí Sarroca',
  'Sant Martí Sesgueioles',
  'Sant Martí Vell',
  'Sant Mateu de Bages',
  'Sant Miquel de Campmajor',
  'Sant Miquel de Fluvià',
  'Sant Mori',
  'Sant Pau de Segúries',
  'Sant Pere de Ribes',
  'Sant Pere de Riudebitlles',
  'Sant Pere de Torelló',
  'Sant Pere de Vilamajor',
  'Sant Pere Pescador',
  'Sant Pere Sallavinera',
  'Sant Pol de Mar',
  'Sant Quintí de Mediona',
  'Sant Quirze de Besora',
  'Sant Quirze del Vallès',
  'Sant Quirze Safaja',
  'Sant Ramon',
  "Sant Sadurní d'Anoia",
  "Sant Sadurní d'Osormort",
  'Sant Salvador de Guardiola',
  'Sant Vicenç de Castellet',
  'Sant Vicenç de Montalt',
  'Sant Vicenç de Torelló',
  'Sant Vicenç dels Horts',
  'Santa Bàrbara',
  'Santa Cecília de Voltregà',
  'Santa Coloma de Cervelló',
  'Santa Coloma de Farners',
  'Santa Coloma de Gramenet',
  'Santa Coloma de Queralt',
  "Santa Cristina d'Aro",
  'Santa Eugènia de Berga',
  'Santa Eulàlia de Riuprimer',
  'Santa Eulàlia de Ronçana',
  'Santa Fe del Penedès',
  "Santa Llogaia d'Àlguema",
  'Santa Margarida de Montbui',
  'Santa Margarida i els Monjos',
  'Santa Maria de Besora',
  'Santa Maria de Martorelles',
  'Santa Maria de Merlès',
  'Santa Maria de Miralles',
  'Santa Maria de Palautordera',
  "Santa Maria d'Oló",
  'Santa Oliva',
  'Santa Pau',
  'Santa Perpètua de Mogoda',
  'Santa Susanna',
  'Santpedor',
  'Sarral',
  'Sarrià de Ter',
  'Sarroca de Bellera',
  'Sarroca de Lleida',
  'Saus, Camallera i Llampaies',
  'Savallà del Comtat',
  'Secuita',
  'la Selva de Mar',
  'la Selva del Camp',
  'Senan',
  'la Sénia',
  'Senterada',
  'la Sentiu de Sió',
  'Sentmenat',
  'Serinyà',
  'Seròs',
  'Serra de Daró',
  'Setcases',
  "la Seu d'Urgell",
  'Seva',
  'Sidamon',
  'Sils',
  'Sitges',
  'Siurana',
  'Sobremunt',
  'el Soleràs',
  'Solivella',
  'Solsona',
  'Sora',
  'Soriguera',
  'Sort',
  'Soses',
  'Subirats',
  'Sudanell',
  'Sunyer',
  'Súria',
  'Susqueda',
  'Tagamanent',
  'Talamanca',
  'Talarn',
  'Talavera',
  "la Tallada d'Empordà",
  'Taradell',
  'Tarragona',
  'Tàrrega',
  'Tarrés',
  'Tarroja de Segarra',
  'Tavèrnoles',
  'Tavertet',
  'Teià',
  'Térmens',
  'Terrades',
  'Terrassa',
  'Tiana',
  'Tírvia',
  'Tiurana',
  'Tivenys',
  'Tivissa',
  'Tona',
  'Torà',
  'Tordera',
  'Torelló',
  'els Torms',
  'Tornabous',
  'la Torre de Cabdella',
  'la Torre de Claramunt',
  'la Torre de Fontaubella',
  "la Torre de l'Espanyol",
  'Torrebesses',
  'Torredembarra',
  'Torrefarrera',
  'Torrefeta i Florejacs',
  'Torregrossa',
  'Torrelameu',
  'Torrelavit',
  'Torrelles de Foix',
  'Torrelles de Llobregat',
  'Torrent',
  'Torres de Segre',
  'Torre-serona',
  'Torroella de Fluvià',
  'Torroella de Montgrí',
  'Torroja del Priorat',
  'Tortellà',
  'Tortosa',
  'Toses',
  'Tossa de Mar',
  'Tremp',
  'Ullà',
  'Ullastrell',
  'Ullastret',
  'Ulldecona',
  'Ulldemolins',
  'Ultramort',
  'Urús',
  'Vacarisses',
  'la Vajol',
  'la Vall de Bianya',
  'la Vall de Boí',
  'Vall de Cardós',
  "la Vall d'en Bas",
  "Vallbona d'Anoia",
  'Vallbona de les Monges',
  'Vallcebre',
  'Vallclara',
  'Vallfogona de Balaguer',
  'Vallfogona de Ripollès',
  'Vallfogona de Riucorb',
  'Vallgorguina',
  'Vallirana',
  'Vall-llobrega',
  'Vallmoll',
  'Vallromanes',
  'Valls',
  "les Valls d'Aguilar",
  'les Valls de Valira',
  "Vandellòs i l'Hospitalet de l'Infant",
  'la Vansa i Fórnols',
  'Veciana',
  'el Vendrell',
  'Ventalló',
  'Verdú',
  'Verges',
  'Vespella de Gaià',
  'Vic',
  'Vidrà',
  'Vidreres',
  'Vielha e Mijaran',
  'Vilabella',
  'Vilabertran',
  'Vilablareix',
  'Vilada',
  'Viladamat',
  'Viladasens',
  'Viladecans',
  'Viladecavalls',
  'Vilademuls',
  'Viladrau',
  'Vilafant',
  'Vilafranca del Penedès',
  'Vilagrassa',
  'Vilajuïga',
  'Vilalba dels Arcs',
  'Vilalba Sasserra',
  'Vilaller',
  'Vilallonga de Ter',
  'Vilallonga del Camp',
  'Vilamacolum',
  'Vilamalla',
  'Vilamaniscle',
  'Vilamòs',
  'Vilanant',
  'Vilanova de Bellpuig',
  'Vilanova de la Barca',
  "Vilanova de l'Aguda",
  'Vilanova de Meià',
  'Vilanova de Prades',
  'Vilanova de Sau',
  'Vilanova de Segrià',
  'Vilanova del Camí',
  'Vilanova del Vallès',
  "Vilanova d'Escornalbou",
  'Vilanova i la Geltrú',
  'Vilaplana',
  'Vila-rodona',
  'Vila-sacra',
  'Vila-sana',
  'Vila-seca',
  'Vilassar de Dalt',
  'Vilassar de Mar',
  'Vilaür',
  'Vilaverd',
  'la Vilella Alta',
  'la Vilella Baixa',
  'Vilobí del Penedès',
  "Vilobí d'Onyar",
  'Vilopriu',
  'el Vilosell',
  'Vimbodí i Poblet',
  'Vinaixa',
  'Vinebre',
  'Vinyols i els Arcs',
  'Viver i Serrateix',
  'Xerta'
];

export const tipusVia = [
  {
    type: '–',
    desc: 'via sense nom'
  },
  {
    type: 'acc.',
    desc: 'Accés'
  },
  {
    type: 'antic',
    desc: 'Antic'
  },
  {
    type: 'actra',
    desc: 'Antiga carretera'
  },
  {
    type: 'apmt.',
    desc: 'Apartaments'
  },
  {
    type: 'autp.',
    desc: 'Autopista'
  },
  {
    type: 'autv.',
    desc: 'Autovia'
  },
  {
    type: 'av.',
    desc: 'Avinguda'
  },
  {
    type: 'bda.',
    desc: 'Baixada'
  },
  {
    type: 'bnc.',
    desc: 'Barranc'
  },
  {
    type: 'b.',
    desc: 'Barri'
  },
  {
    type: 'bloc',
    desc: 'Bloc, blocs'
  },
  {
    type: 'cda.',
    desc: 'Calçada'
  },
  {
    type: 'camí',
    desc: 'Camí'
  },
  {
    type: 'cant.',
    desc: 'Cantonada'
  },
  {
    type: 'c.',
    desc: 'Carrer'
  },
  {
    type: 'ca.',
    desc: 'Carrerada'
  },
  {
    type: 'cró.',
    desc: 'Carreró'
  },
  {
    type: 'ctra.',
    desc: 'Carretera'
  },
  {
    type: 'cses.',
    desc: 'Cases'
  },
  {
    type: 'cinto',
    desc: 'Cinturó'
  },
  {
    type: 'cval.',
    desc: 'Circumval·lació'
  },
  {
    type: 'col.',
    desc: 'Colònia'
  },
  {
    type: 'comp.',
    desc: 'Complex'
  },
  {
    type: 'conj.',
    desc: 'Conjunt'
  },
  {
    type: 'crral',
    desc: 'Corraló'
  },
  {
    type: 'cdor.',
    desc: 'Corredor'
  },
  {
    type: 'crol.',
    desc: 'Corriol'
  },
  {
    type: 'cos.',
    desc: 'Costa (via amb pendent)'
  },
  {
    type: 'disse',
    desc: 'Disseminat'
  },
  {
    type: 'drec.',
    desc: 'Drecera'
  },
  {
    type: 'eix',
    desc: 'Eix'
  },
  {
    type: 'ellaç',
    desc: 'Enllaç'
  },
  {
    type: 'esc.',
    desc: 'Escala (via amb escales)'
  },
  {
    type: 'esp.',
    desc: 'Esplanada'
  },
  {
    type: 'fin.',
    desc: 'Finca'
  },
  {
    type: 'glor.',
    desc: 'Glorieta'
  },
  {
    type: 'gv',
    desc: 'Gran Via'
  },
  {
    type: 'gr.',
    desc: 'Grup'
  },
  {
    type: 'illa',
    desc: 'Illa'
  },
  {
    type: 'j.',
    desc: 'Jardí, jardins'
  },
  {
    type: 'lloc',
    desc: 'Lloc'
  },
  {
    type: 'mira.',
    desc: 'Mirador'
  },
  {
    type: 'moll',
    desc: 'Moll'
  },
  {
    type: 'mur.',
    desc: 'Muralla'
  },
  {
    type: 'pge.',
    desc: 'Paratge'
  },
  {
    type: 'parc',
    desc: 'Parc'
  },
  {
    type: 'par.',
    desc: 'Partida'
  },
  {
    type: 'pas',
    desc: 'Pas'
  },
  {
    type: 'pdís.',
    desc: 'Passadís'
  },
  {
    type: 'ptge.',
    desc: 'Passatge'
  },
  {
    type: 'pg.',
    desc: 'Passeig'
  },
  {
    type: 'psera',
    desc: 'Passera'
  },
  {
    type: 'pista',
    desc: 'Pista'
  },
  {
    type: 'pla',
    desc: 'Pla'
  },
  {
    type: 'pl.',
    desc: 'Plaça'
  },
  {
    type: 'plta.',
    desc: 'Placeta'
  },
  {
    type: 'plana',
    desc: 'Plana'
  },
  {
    type: 'pja.',
    desc: 'Platja'
  },
  {
    type: 'pol.',
    desc: 'Polígon'
  },
  {
    type: 'pi.',
    desc: 'Polígon industrial'
  },
  {
    type: 'pont',
    desc: 'Pont'
  },
  {
    type: 'port',
    desc: 'Port'
  },
  {
    type: 'pta.',
    desc: 'Porta'
  },
  {
    type: 'ptal.',
    desc: 'Portal'
  },
  {
    type: 'ptals',
    desc: 'Portals'
  },
  {
    type: 'prol.',
    desc: 'Prolongació'
  },
  {
    type: 'pda.',
    desc: 'Pujada'
  },
  {
    type: 'racó',
    desc: 'Racó'
  },
  {
    type: 'rail',
    desc: 'Rail'
  },
  {
    type: 'ramal',
    desc: 'Ramal'
  },
  {
    type: 'rbla.',
    desc: 'Rambla'
  },
  {
    type: 'rblt.',
    desc: 'Rambleta'
  },
  {
    type: 'rasa',
    desc: 'Rasa'
  },
  {
    type: 'rav.',
    desc: 'Raval (carrer)'
  },
  {
    type: 'raval',
    desc: 'Raval (barri)'
  },
  {
    type: 'rial',
    desc: 'Rial'
  },
  {
    type: 'ra.',
    desc: 'Riera'
  },
  {
    type: 'rda.',
    desc: 'Ronda'
  },
  {
    type: 'rot.',
    desc: 'Rotonda'
  },
  {
    type: 'sec.',
    desc: 'Sector'
  },
  {
    type: 'send.',
    desc: 'Sender'
  },
  {
    type: 'sèq.',
    desc: 'Sèquia'
  },
  {
    type: 'NC',
    desc: 'via sense tipus'
  },
  {
    type: 't.',
    desc: 'Torrent'
  },
  {
    type: 'trav.',
    desc: 'Travessera'
  },
  {
    type: 'trv.',
    desc: 'Travessia'
  },
  {
    type: 'tunel',
    desc: 'Túnel'
  },
  {
    type: 'urb.',
    desc: 'Urbanització'
  },
  {
    type: 'veï.',
    desc: 'Veïnat'
  },
  {
    type: 'via',
    desc: 'Via'
  },
  {
    type: 'vdct.',
    desc: 'Viaducte'
  },
  {
    type: 'vial',
    desc: 'Vial'
  },
  {
    type: 'zona',
    desc: 'Zona'
  }
];
